// 步骤二-农村土地录入标的信息
<template>
  <div class="container-main" v-loading="Loading">
    <div class="top-title">挂牌申请</div>
    <div class="main">
      <ApplicationSteps
        class="m50"
        :activeNumber="activeNumber"
        :titleArray="titleArray"
      />
      <el-form
        class="m50"
        ref="formRef"
        :rules="rules"
        :model="formData"
        label-width="180px"
        label-position="left"
        size="mini"
      >
        <div class="h_bg p50">
          <h3>标的信息</h3>
          <span>带"<span class="redF xing">*</span>"号为必填项</span>
        </div>
        <div class="m50">
          <el-form-item label="标的名称" prop="name">
            <el-input
              v-model="formData.name"
              placeholder="请输入标的名称"
              :maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="标的坐落所在地区" prop="address">
            <area-tree
              v-if="formData.address"
              style="width: 300px"
              v-model="formData.address"
              @areaId="changeArea"
            ></area-tree>
          </el-form-item>
          <el-form-item label="" prop="village">
            <el-input
              v-model="formData.village"
              placeholder="请输入详细地址（如村、庄等）"
            ></el-input>
          </el-form-item>
          <el-form-item label="承包方式" prop="contractingMode">
            <el-select
              v-model="formData.contractingMode"
              style="margin-right: 10px"
            >
              <el-option
                v-for="item in areaStatus"
                :key="item.key"
                :label="item.value"
                :value="item.value"
                placeholder="请选择承包方式"
              ></el-option>
            </el-select>
            <el-input
              v-if="formData.contractingMode == '其他'"
              v-model="formData.otherContractingMode"
              placeholder="请输入承包方式"
            ></el-input>
          </el-form-item>
          <el-form-item label="土地四至" prop="fourSide">
            <el-input
              v-model="formData.fourSide"
              placeholder="请输入土地四至"
            ></el-input>
          </el-form-item>
          <el-form-item label="持有面积" prop="holdArea">
            <el-input
              class="half"
              v-model="formData.holdArea"
              @keyup.native="changeCode('holdArea')"
              placeholder="请输入占地面积"
              @blur="holdAreaChange"
            >
            </el-input>
            <el-select
              v-model="formData.holdAreaUnit"
              placeholder="请选择面积单位"
              class="half"
              @change="holdAreaChange"
            >
              <el-option
                v-for="(item, index) in forestAttrList"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <span
              v-if="
                formData.holdAreaUnit != '亩' && holdAreaNum && holdAreaNum > 0
              "
              >{{ `≈${holdAreaNum}亩` }}</span
            >
          </el-form-item>
          <el-form-item label="转让期限" prop="transferPeriod">
            <el-date-picker
              v-model="formData.transferPeriod"
              type="date"
              prefix-icon="false"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="土地类型" prop="landType">
            <el-input
              v-model="formData.landType"
              placeholder="请输入土地类型"
            ></el-input>
          </el-form-item>
          <el-form-item label="用途" prop="usePurpose">
            <el-input
              v-model="formData.usePurpose"
              placeholder="请输入用途"
            ></el-input>
          </el-form-item>
          <el-form-item label="权属类型" prop="ownershipType">
            <el-select
              v-model="formData.ownershipType"
              placeholder="请选择权属类型"
            >
              <el-option label="集体" value="集体"></el-option>
              <el-option label="个人" value="个人"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所有权人" prop="owner">
            <el-input
              v-model="formData.owner"
              placeholder="请输入所有权人"
            ></el-input>
          </el-form-item>
          <el-form-item label="权证名称" prop="warrantName">
            <el-input
              v-model="formData.warrantName"
              placeholder="请输入权证名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="权证年限">
            <el-input
              v-model="formData.warrantTerm"
              placeholder="请输入权证年限"
            ></el-input>
          </el-form-item>
          <el-form-item label="转出方式" prop="transferMethod">
            <el-input
              v-model="formData.transferMethod"
              placeholder="请输入转出方式"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否属于再次转出" prop="isReTransfer">
            <el-radio-group v-model="formData.isReTransfer">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否有优先受让方" prop="isPriorTransfer">
            <el-radio-group v-model="formData.isPriorTransfer">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否存在他项权利人" prop="isOtherRightsHolder">
            <el-radio-group v-model="formData.isOtherRightsHolder">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="他项权利人"
            v-if="formData.isOtherRightsHolder == 1"
            prop="otherRightsHolder"
          >
            <el-input
              v-model="formData.otherRightsHolder"
              placeholder="请输入他项权利人"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="他项权利内容"
            v-if="formData.isOtherRightsHolder == 1"
            prop="otherRightsContent"
          >
            <el-input
              v-model="formData.otherRightsContent"
              placeholder="请输入他项权利内容"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="相关人员是否放弃优先权"
            prop="isGiveUpAdvanceRight"
          >
            <el-radio-group v-model="formData.isGiveUpAdvanceRight">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="标的图">
            <Upload
              v-model="imgUrl"
              buttonText="上传"
              @fileNameEvt="fileNameEvt"
              :size="true"
            ></Upload>
            <div v-for="(item, index) in formData.imgList" :key="index">
              <div class="lookAddr">
                <span class="name">{{ item.imgName }}</span>
                <el-link
                  class="mr20 blueC"
                  :underline="false"
                  v-if="item.imgUrl"
                  :href="item.imgUrl"
                  target="_blank"
                  >详情</el-link
                >
                <i @click.prevent.stop="dels(index)" class="el-icon-delete"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item style="margin-top: 20px" label="标的简介">
            <el-input
              maxlength="500"
              show-word-limit
              v-model="formData.describe"
              type="textarea"
              :rows="3"
            ></el-input>
          </el-form-item>
        </div>
        <div class="h_bg p50">
          <h3>交易信息</h3>
          <span>带"<span class="redF xing">*</span>"号为必填项</span>
        </div>
        <div class="m50">
          <el-form-item label="交易方式" prop="tranferType">
            <el-radio-group
              v-model="formData.tranferType"
              @change="tranferTypeChange"
            >
              <el-radio :label="1">竞拍</el-radio>
              <el-radio :label="2">非竞拍</el-radio>
              <el-radio :label="3">预售</el-radio>
               <el-radio :label="4">线下交易</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="formData.tranferType != 4">
            <el-form-item
              :label="formData.tranferType == 1 ? '起拍价格' : '标的价格'"
              prop="amount"
            >
              <el-input
                v-model="formData.amount"
                @keyup.native="changeCode('amount')"
                :placeholder="
                  formData.tranferType == 1
                    ? '请输入起拍价格'
                    : '请输入标的价格'
                "
                :maxlength="15"
                class="half"
              >
              </el-input>
              <el-select v-model="formData.amountUnit" class="half">
                <el-option
                  label="元"
                  :value="'1'"
                  placeholder="请选择"
                ></el-option>
                <el-option label="万元" :value="'2'"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="预付款" prop="isAdvancePayment">
              <el-select
                @change="advancePaymentChange"
                v-model="formData.isAdvancePayment"
                placeholder="是/否"
                class="mr10"
                style="width: 100px"
              >
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label=""
              prop="advancePaymentAmount"
              v-if="formData.isAdvancePayment == 1"
            >
              <el-input
                v-model="formData.advancePaymentAmount"
                @keyup.native="changeCode('advancePaymentAmount')"
                placeholder="请输入预付款"
                :maxlength="15"
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item
              label="交易付款方式"
              prop="payWay"
              v-if="isShowPayWay"
            >
              <el-radio-group v-model="formData.payWay">
                <el-radio :label="1">一次性支付</el-radio>
                <el-radio :label="2" :disabled="formData.isAdvancePayment==1">分期支付</el-radio>
              </el-radio-group>
            </el-form-item>
            <span class="tips-span" v-if="isShowPayWay"
              >分期支付不支持预付款、保证金支付</span
            >
          </div>
          <div v-else>
            <el-form-item label="标的价格">
              <label>价格面议</label>
            </el-form-item>
          </div>
        </div>
        <div class="h_bg p50">
          <h3>标的物所属主体信息</h3>
          <span>带"<span class="redF xing">*</span>"号为必填项</span>
        </div>
        <div class="m50">
          <el-form-item label="主体身份" prop="mainPartIdentityType">
            <el-radio-group
              disabled
              v-model="formData.mainPartIdentityType"
              @change="restMainPartInfo()"
            >
              <el-radio :label="1">企业</el-radio>
              <!--              <el-radio :label="2">组织</el-radio>-->
              <el-radio :label="3">个人</el-radio>
              <el-radio :label="4">行政事业单位</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="
              formData.mainPartIdentityType == 1
                ? '企业名称'
                : formData.mainPartIdentityType == 2
                ? '组织名称'
                : formData.mainPartIdentityType == 4
                ? '单位名称'
                : '姓名'
            "
            prop="mainPartIdentityName"
          >
            <el-input
              disabled
              v-model="formData.mainPartIdentityName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="统一信用代码"
            prop="mainPartCreditCode"
            v-if="
              formData.mainPartIdentityType == 1 ||
              formData.mainPartIdentityType == 2
            "
          >
            <el-input
              disabled
              v-model="formData.mainPartCreditCode"
              placeholder="请输入统一信用代码"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="注册地址" prop="mainPartRegistAddrss" v-if="formData.mainPartIdentityType==1||formData.mainPartIdentityType==2"> -->
          <el-form-item
            :label="formData.mainPartIdentityType == 4 ? '住所' : '注册地址'"
            prop="mainPartRegistAddrss"
            v-if="formData.mainPartIdentityType != 3"
          >
            <el-input
              disabled
              v-model="formData.mainPartRegistAddrss"
              placeholder="请输入注册地址"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="法定代表人" prop="mainPartLegalName" v-if="formData.mainPartIdentityType==1||formData.mainPartIdentityType==2"> -->
          <el-form-item
            :label="
              formData.mainPartIdentityType == 4 ? '代表人' : '法定代表人'
            "
            prop="mainPartLegalName"
            v-if="formData.mainPartIdentityType != 3"
          >
            <el-input
              disabled
              v-model="formData.mainPartLegalName"
              placeholder="请输入法定代表人"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="身份证号"
            prop="mainPartIdNumber"
            v-if="formData.mainPartIdentityType == 3"
          >
            <el-input
              disabled
              v-model="formData.mainPartIdNumber"
              placeholder="请输入身份证号"
              :maxlength="18"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系人"
            prop="mainPartContactPerson"
            v-if="formData.mainPartIdentityType != 3"
          >
            <el-input
              v-model="formData.mainPartContactPerson"
              placeholder="请输入联系人"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="mainPartContactNumber">
            <el-input
              v-model="formData.mainPartContactNumber"
              placeholder="请输入联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系地址"
            prop="mainPartContactAddress"
            v-if="formData.mainPartIdentityType != 3"
          >
            <el-input
              v-model="formData.mainPartContactAddress"
              placeholder="请输入联系地址"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div>
        <div class="h_bg p50">
          <h3>所需资料</h3>
          <span>（支持上传pdf或图片格式）</span>
        </div>
        <el-form class="form">
          <el-row class="mt20">
            <el-col v-for="item of roleFileList" :key="item.fileNameKey">
              <div v-if="item.maxNumber == 1">
                <el-form-item
                  :class="{ actives: item.isRequire }"
                  :label="item.fileName"
                  label-width="390px"
                  style="margin-bottom: 0;height:40px;"
                >
                  <OneUpload
                    style="display: inline-block; margin-left: 50px"
                    :fileFuther="item"
                    :downFlag="downFlag"
                  />
                </el-form-item>
              </div>
              <div v-else>
                <el-form-item
                  :class="{ actives: item.isRequire }"
                  :label="`${item.fileName}(可上传多份)`"
                  label-width="390px"
                  style="margin-bottom: 0"
                >
                  <ListUpload
                    style="display: inline-block; margin-left: 50px"
                    :fileFuther="item"
                    :downFlag="downFlag"
                  />
                </el-form-item>
              </div>
            </el-col>
            <div>
              <Upload
                v-model="otherImgUrl"
                buttonText="上传其他资料"
                @fileNameEvt="fileNameOtherEvt"
                :size="true"
              ></Upload>
              <div v-for="(item, ind) of formData.otherFileList" :key="ind">
                <el-form-item
                  :label="item.fileName"
                  label-width="390px"
                  style="margin-bottom: 0"
                >
                  <OtherOneUpload
                    style="display: inline-block; margin-left: 50px"
                    :fileFuther="item"
                    :index="ind"
                    @delOtherImg="delOtherImg()"
                  />
                </el-form-item>
              </div>
            </div>
          </el-row>
        </el-form>
        <AgreeDialog
          ref="agree"
          @checkAgree="checkAgreeEvt"
          @agreementName="getAgreeName"
        ></AgreeDialog>
      </div>
    </div>
    <div class="btn" style="text-align: right">
      <el-button @click="$router.go(-1)">上一步</el-button>
      <el-button @click="saveDisable && save()">保存</el-button>
      <el-button class="sumbit" @click="sumbitDisable && sumbitEvt()"
        >提交</el-button
      >
    </div>
    <dialog-contract @listing="submitData" :contractData="contractData" ref="dialogContract" v-if="isShowContract"></dialog-contract>
  </div>
</template>
<script>
import publicFunction from '@/utils/publicFunction'
import DialogContract from "./components/DialogContract";
import OneUpload from "@/components/DataUpload/OneUpload.vue";
import ListUpload from "@/components/DataUpload/ListUpload.vue";
import ApplicationSteps from "@/components/ApplicationSteps"; // 步骤组件
import { addrOptions, forestOptions } from "@/common/options.js";
import Upload from "@/components/Upload/UpLoad.vue";
import AreaTree from "./components/AreaTree";
import OtherOneUpload from "@/components/DataUpload/OtherOneUpload.vue";
import AgreeDialog from "@/components/agreeDialog";
import { sessionStore } from "@/utils/data-management";
export default {
  components: {
    ApplicationSteps,
    OneUpload,
    ListUpload,
    Upload,
    AreaTree,
    OtherOneUpload,
    AgreeDialog,
    DialogContract,
  },
  data() {
    return {
      years: 1, //合同有效期限
      contractData: {},
      isShowContract: false,
      saveDisable: true,
      sumbitDisable: true,
      activeNumber: 2,
      titleArray: ["选择业务类型", "录入标的信息", "确认挂牌"],
      projectSortOptions: addrOptions,
      projectRegionOptions: forestOptions,
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        usePurpose: [{ required: true, message: "请输入", trigger: "blur" }],
        owner: [{ required: true, message: "请输入", trigger: "blur" }],
        isOtherRightsHolder: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        otherRightsHolder: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        transferPeriod: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        otherRightsContent: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        isGiveUpAdvanceRight: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        address: [{ required: true, message: "请输入", trigger: "change" }],
        village: [{ required: true, message: "请输入", trigger: "blur" }],
        contractingMode: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        fourSide: [{ required: true, message: "请输入", trigger: "change" }],
        otherContractingMode: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        holdArea: [{ required: true, message: "请输入", trigger: "blur" }],
        tranferType: [{ required: true, message: "请输入", trigger: "blur" }],
        amount: [{ required: true, message: "请输入", trigger: "blur" }],
        isAdvancePayment: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        payWay: [{ required: true, message: "请选择", trigger: "change" }],
        advancePaymentAmount: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        landType: [{ required: true, message: "请输入", trigger: "blur" }],
        ownershipType: [{ required: true, message: "请输入", trigger: "change" }],
        warrantName: [{ required: true, message: "请输入", trigger: "blur" }],
        transferMethod: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        isReTransfer: [
          { required: true, message: "请输入", trigger: "change" },
        ],
        isPriorTransfer: [
          { required: true, message: "请输入", trigger: "change" },
        ],
        mainPartIdentityType: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        mainPartIdentityName: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        mainPartCreditCode: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        mainPartRegistAddrss: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        mainPartLegalName: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        mainPartIdNumber: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        mainPartContactPerson: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        mainPartContactNumber: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        mainPartContactAddress: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
      },
      formData: {
        payWay: 1,
        areaConfigId: "",
        businessType: "1", //业务类型
        name: "", //标的名称
        usePurpose: "", //土地用途
        owner: "", //所有权人
        isOtherRightsHolder: 2, //是否存在他项权利人
        otherRightsHolder: "", //他项权利人
        otherRightsContent: "", //他项权利内容
        isGiveUpAdvanceRight: 2, //相关人员是否放弃优先权
        location: "", //所在地区 总地址
        contractingMode: "", //承包方式
        otherContractingMode: "",
        holdArea: "", //持有面积
        tranferType: 1, //交易方式
        amount: "", //标的价格
        submitGoodsTime: "", //交货时间
        isAdvancePayment: "", //预付款
        advancePaymentAmount: "", //预付款金额
        fileList: [],
        transferPeriod: "", //转让期限
        address: "",
        village: "",
        imgList: [], //标的图
        fourSide: "", //土地四至
        landType: "", //土地类型
        ownershipType: "", //权属类型
        warrantName: "", //权证名称
        warrantTerm: "", //权证年限
        transferMethod: "", //转出方式
        isReTransfer: 2, //是否属于再次转出   1 是  2 否
        isPriorTransfer: 2, //是否有优先受让方   1 是  2 否
        otherFileList: [], // 其他文件  fileName 和 fileUrl
        holdAreaUnit: "公顷",
        mainPartIdentityType: 1, //主体身份类型  1企业 2组织  3个人
        mainPartIdentityName: "",
        mainPartCreditCode: "",
        mainPartRegistAddrss: "",
        mainPartLegalName: "",
        mainPartContactPerson: "",
        mainPartContactNumber: "",
        mainPartContactAddress: "",
        mainPartIdNumber: "",
        listingMainPart: {
          identityType: "", //主体身份类型  1企业 2组织  3个人
          name: "", //企业名称/组织名称/姓名
          creditCode: "", //统一信用代码
          registAddrss: "", //注册地址
          legalName: "", //法定代表人
          contactPerson: "", //联系人
          contactNumber: "", //联系电话
          contactAddress: "", //联系地址
          idNumber: "", //身份证号  ;
        },
        amountUnit: "1",
      },
      holdAreaNum: "", //亩
      forestAttrList: ["亩", "公顷", "平方米", "平方千米"],
      imgUrl: "", // 标的图的url
      fileName: "", //标的图的name
      otherImgUrl: "", // 其他资料的url
      otherFileName: "", //其他资料的name
      downFlag: true,
      roleFileList: [],
      roleFileList2: [],
      Loading: false,
      areaStatus: [], //承包方式
      pickerOptions: {
        disabledDate: (time) => {
          return this.dealDisabledDate(time);
        },
      },
      agreementName: "",
      checkAgree: false,
    };
  },
  computed: {
    storeArea() {
      return this.$store.state.cityArea;
    },
    isShowPayWay() {
      let showFlag = true;
      if (this.formData.isAdvancePayment == 1) {
        let amount =
          this.formData.amount * (this.formData.amountUnit == "2" ? 10000 : 1);
        if (
          [2, 3].indexOf(this.formData.tranferType) > -1 &&
          this.formData.advancePaymentAmount >= amount
        ) {
          showFlag = false;
        }
      }
      return showFlag;
    },
  },
  watch: {
    imgUrl: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData.imgList.push({
            imgUrl: newVal,
            imgName: this.fileName,
          });
          this.imgUrl = "";
          this.fileName = "";
        }
      },
    },
    otherImgUrl: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData.otherFileList.push({
            fileUrl: newVal,
            fileName: this.otherFileName,
          });
          this.otherImgUrl = "";
          this.otherFileName = "";
        }
      },
    },
  },
  methods: {
    advancePaymentChange(val){
      if(val==1){
        this.formData.payWay = 1
      }
    },
    restMainPartInfo() {
      this.formData.mainPartIdentityName = ""; //企业名称/组织名称/姓名
      (this.formData.mainPartCreditCode = ""), //统一信用代码
        (this.formData.mainPartRegistAddrss = ""), //注册地址
        (this.formData.mainPartLegalName = ""), //法定代表人
        (this.formData.mainPartContactPerson = ""); //联系人
      this.formData.mainPartContactNumber = ""; //联系电话
      this.formData.mainPartContactAddress = ""; //联系地址
      this.formData.mainPartIdNumber = ""; //身份证号  ;
    },
    holdAreaChange() {
      if (this.formData.holdAreaUnit == "公顷") {
        this.holdAreaNum = (this.formData.holdArea * 1 * 15).toFixed(2);
      } else if (this.formData.holdAreaUnit == "平方千米") {
        this.holdAreaNum = (this.formData.holdArea * 1 * 1500).toFixed(2);
      } else {
        this.holdAreaNum = (this.formData.holdArea * 1 * 0.0015).toFixed(4);
      }
    },
    delOtherImg(v) {
      if (this.formData.otherFileList.length > 0) {
        this.formData.otherFileList.splice(v, 1);
      }
    },
    fileNameOtherEvt(v) {
      this.otherFileName = v;
    },
    fileNameEvt(v) {
      this.fileName = v;
    },
    dels(index) {
      if (this.formData.imgList.length > 0) {
        this.formData.imgList.splice(index, 1);
      }
    },
    async getAreaCodeById() {
      await this.$api.user
        .getAreaCodeById({ areaConfigId: this.storeArea.areaConfigId })
        .then((res) => {
          this.formData.address =
            res.data.provinceName +
            "/" +
            res.data.cityName +
            "/" +
            (res.data.areaName ? res.data.areaName : "/") +
            "/";
        });
    },
    //获取承包方式
    getAreaStatus() {
      this.$api.user
        .getByCategoryName({ categoryName: "contract_mode" })
        .then((res) => {
          this.areaStatus = res.data;
          this.areaStatus.push({ key: 11111, value: "其他" });
        });
    },
    dealDisabledDate(time) {
      return time.getTime() < Date.now() - 8.64e7;
    },
    changeArea(e) {
      this.$refs.agree.getRule(e);
    },
    save() {
      if (
        !this.formData.address ||
        this.formData.address == "广西壮族自治区/百色市///"
      ) {
        return this.$message.error(`请选择地区`);
      }
      this.Loading = true;
      this.sumbitDisable = false;
      let directionalFinancingFiles = [];
      this.roleFileList.forEach((item) => {
        const obj = {
          fileName: item.fileName,
          fileUrl: [],
          fileType: item.fileType,
          canDownload: item.canDownload,
          downloadUrl: item.downloadUrl,
          maxNumber: item.maxNumber,
          isRequire: item.isRequire,
        };
        if (item.maxNumber == 1 && item.fileList[0]) {
          obj.fileUrl.push(item.fileList[0].fileUrl || "");
        } else {
          item.fileList.forEach((i) => {
            obj.fileUrl.push(i.fileUrl || "");
          });
        }
        directionalFinancingFiles.push(obj);
      });
      this.formData.fileList = directionalFinancingFiles;
      this.formData.areaConfigId = this.storeArea.areaConfigId;
      this.formData.location =
        this.formData.address + "/" + this.formData.village;
      const a = this.formData.address.split("/");
      this.$set(this.formData, "province", a[0]);
      this.$set(this.formData, "city", a[1]);
      this.$set(this.formData, "county", a[2]);
      this.$set(this.formData, "township", a[3]);
      this.formData.listingMainPart.identityType =
        this.formData.mainPartIdentityType;
      this.formData.listingMainPart.name = this.formData.mainPartIdentityName;
      this.formData.listingMainPart.creditCode =
        this.formData.mainPartCreditCode;
      this.formData.listingMainPart.registAddrss =
        this.formData.mainPartRegistAddrss;
      this.formData.listingMainPart.legalName = this.formData.mainPartLegalName;
      this.formData.listingMainPart.contactPerson =
        this.formData.mainPartContactPerson;
      this.formData.listingMainPart.contactNumber =
        this.formData.mainPartContactNumber;
      this.formData.listingMainPart.contactAddress =
        this.formData.mainPartContactAddress;
      this.formData.listingMainPart.idNumber = this.formData.mainPartIdNumber;
      this.$api.my
        .saveRuralLand(this.formData)
        .then((res) => {
          if (res.code == 1000) {
            this.$message.success("保存成功");
            setTimeout(() => {
              this.$router.push({ name: "MyApplyList" });
            }, 1500);
          } else {
            this.sumbitDisable = true;
          }
        })
        .catch((error) => {
          this.sumbitDisable = true;
        })
        .finally(() => {
          setTimeout(() => {
            this.Loading = false;
          }, 1400);
        });
    },
    //生成合同
    generateContract(id,obj){
      obj.equityTransaction.listingApplyId = id
      this.$api.apply.equityTransactionSignature(obj)
    },
    submitData(contractData){
      let directionalFinancingFiles = []
      this.Loading = true;
      this.saveDisable = false;
      this.roleFileList.forEach((item) => {
        const obj = {
          fileName: item.fileName,
          fileUrl: [],
          fileType: item.fileType,
          canDownload: item.canDownload,
          downloadUrl: item.downloadUrl,
          maxNumber: item.maxNumber,
          isRequire: item.isRequire,
        };
        if (item.maxNumber == 1 && item.fileList[0]) {
          obj.fileUrl.push(item.fileList[0].fileUrl || "");
        } else {
          item.fileList.forEach((i) => {
            obj.fileUrl.push(i.fileUrl || "");
          });
        }
        directionalFinancingFiles.push(obj);
      });
      this.formData.fileList = directionalFinancingFiles;
      this.formData.areaConfigId = this.storeArea.areaConfigId;
      this.formData.location =
          this.formData.address + "/" + this.formData.village;
      const a = this.formData.address.split("/");
      this.$set(this.formData, "province", a[0]);
      this.$set(this.formData, "city", a[1]);
      this.$set(this.formData, "county", a[2]);
      this.$set(this.formData, "township", a[3]);
      this.formData.listingMainPart.identityType =
          this.formData.mainPartIdentityType;
      this.formData.listingMainPart.name =
          this.formData.mainPartIdentityName;
      this.formData.listingMainPart.creditCode =
          this.formData.mainPartCreditCode;
      this.formData.listingMainPart.registAddrss =
          this.formData.mainPartRegistAddrss;
      this.formData.listingMainPart.legalName =
          this.formData.mainPartLegalName;
      this.formData.listingMainPart.contactPerson =
          this.formData.mainPartContactPerson;
      this.formData.listingMainPart.contactNumber =
          this.formData.mainPartContactNumber;
      this.formData.listingMainPart.contactAddress =
          this.formData.mainPartContactAddress;
      this.formData.listingMainPart.idNumber =
          this.formData.mainPartIdNumber;
      this.$api.my
          .ruralLandSubmit(this.formData)
          .then((res) => {
            if (res.code == 1000) {
              this.generateContract(res.data.id,contractData)
              this.$message.success("提交成功");
              setTimeout(() => {
                this.$router.push({
                  name: "PropertyListingApplication",
                  query: { activeNumber: 3 },
                });
              }, 1500);
            } else {
              this.saveDisable = true;
            }
          })
          .catch((error) => {
            this.saveDisable = true;
          })
          .finally(() => {
            setTimeout(() => {
              this.Loading = false;
            }, 1400);
          });
    },
    sumbitEvt() {
      this.$refs.formRef.validate((v) => {
        if (v) {
          console.log("this.formData", this.formData);
          if (
            this.formData.contractingMode == "其他" &&
            !this.formData.otherContractingMode
          )
            return this.$message.error(`请输入其他方式`);
          if (this.agreementName && !this.checkAgree)
            return this.$message.error(`请阅读并勾选《${this.agreementName}》`);
          const check = this.checkFileAddr(this.roleFileList);
          if (check) {
            this.$confirm("确认提交?", "提示", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(async () => {
                this.isShowContract = true
                let amount = ''
                if(this.formData.tranferType==4){
                  amount = '(价格面议)'
                }else {
                  amount = this.formData.amountUnit==2?publicFunction.accMul(this.formData.amount,10000):this.formData.amount
                }
                this.contractData = {
                  mainPartIdentityName: this.formData.mainPartIdentityName,
                  createDate: publicFunction.dateFormat(new Date(),'yyyy年MM月dd日'),
                  name: this.formData.name,
                  //规格
                  holdAreaUnit: this.formData.holdAreaUnit,
                  //数量
                  holdArea: this.formData.holdArea,
                  //单价
                  unitPrice: this.formData.tranferType==4?'(价格面议)':(amount/this.formData.holdArea).toFixed(2),
                  //总价
                  amount,
                  //服务费率
                  serviceRate: publicFunction.judgeServiceRate(amount),
                  mainPartContactNumber: this.formData.mainPartContactNumber
                }
                this.$nextTick(()=>{
                  this.$refs.dialogContract.init()
                })
                // await this.getContractValidity()
                //   let amount = ''
                // if(this.formData.tranferType==4){
                //   amount = '(价格面议)'
                // }else {
                //   amount = this.formData.amountUnit==2?publicFunction.accMul(this.formData.amount,10000):this.formData.amount
                // }
                // this.contractData = {
                //   equityTransaction: {
                //     name: this.formData.mainPartIdentityName,
                //     phone: this.formData.mainPartContactNumber,
                //     listApplyName: this.formData.name,
                //     holdArea: this.formData.holdArea,
                //     holdAreaUnit: this.formData.holdAreaUnit,
                //     amount,
                //     price: (amount/Number(this.formData.holdArea)).toFixed(2),
                //     years: this.years,
                //     proportion: publicFunction.judgeServiceRate(amount),
                //   }
                // }
                // this.submitData(this.contractData)
              })
              .catch(() => {});
          }
        } else {
          this.$nextTick(() => {
            let isError = document.getElementsByClassName("is-error");
            let errorStr = isError[0].innerText.split("\n")[0] || "";
            isError[0].scrollIntoView({
              block: "center",
              behavior: "smooth",
            });
            this.$message.error(`请设置"${errorStr}"后提交!`);
          });
        }
      });
    },
  //获取合同有效期限
  //   getContractValidity(){
  //     return this.$api.user.getByCategoryName({ categoryName: 'contractValidity' })
  //         .then(res=>{
  //           if(res.code===1000){
  //             this.years = res.data[0]?res.data[0].key*1:1
  //           }
  //         })
  //   },
    tranferTypeChange(v) {
      this.formData.amount = "";
    },
    checkFileAddr(list) {
      return (
        list &&
        list.every((item) => {
          if (item.isRequire && item.fileList.length < 1) {
            this.$message.error(`请将《${item.fileName}》的相关资料上传完善`);
            return false;
          } else {
            return true;
          }
        })
      );
    },
    // 获取流程需要的文件 农村
    async getProcessFiles() {
      this.roleFileList = [];
      await this.$api.my
        .getProcessFiles({
          generatePosition: 10,
          role: "listing-person",
          listingMode: 10,
        })
        .then((res) => {
          if (res.code === 1000) {
            const fileListData = res.data;
            fileListData.forEach((item, index) => {
              this.$set(item, "status", false);
              item.fileList = [];
            });
            this.roleFileList = fileListData;
          }
        })
        .catch((err) => {});
    },
    changeCode(name) {
      this.$nextTick(() => {
        if (this.formData[`${name}`] != null) {
          this.formData[`${name}`] = this.formData[`${name}`].replace(
            /[^\d.]/g,
            ""
          );
        }
      });
    },
    getAgreeName(v) {
      this.agreementName = v;
    },
    checkAgreeEvt(v) {
      this.checkAgree = v;
    },
  },
  async created() {
    await this.getAreaStatus();
    await this.getAreaCodeById();
    await this.getProcessFiles();
    if (sessionStore.get("userInfo")) {
      const userInfo = sessionStore.get("userInfo");
      this.$set(
        this.formData,
        "mainPartIdentityType",
        userInfo.userType === 2
          ? 1
          : userInfo.userType === 1
          ? 3
          : userInfo.userType === 3
          ? 4
          : null
      );
      if (userInfo.userType === 2 || userInfo.userType === 3) {
        this.$set(this.formData, "mainPartIdentityName", userInfo.companyName);
        this.$set(
          this.formData,
          "mainPartCreditCode",
          userInfo.unifiedCreditCode
        );
        this.$set(
          this.formData,
          "mainPartRegistAddrss",
          userInfo.registAddress
        );
        this.$set(this.formData, "mainPartLegalName", userInfo.name);
      }
      if (userInfo.userType === 1) {
        this.$set(this.formData, "mainPartIdentityName", userInfo.name);
        this.$set(this.formData, "mainPartIdNumber", userInfo.idCard);
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.container-main {
  width: 1080px;
  margin: 50px auto 0;
  background: #fff;
  width: 1200px;
  padding: 30px;
  .main {
    margin: 0 97px;
  }
  .el-form {
    .el-form-item {
      .el-input,
      .el-select {
        width: 300px;
        /deep/ input {
          height: 30px;
          background: rgba(255, 255, 255, 1);
          border-radius: 2px;
          border: 1px solid rgba(240, 240, 240, 1);
          padding: 9px 10px;
        }
      }
      .el-textarea {
        /deep/ textarea {
          border-radius: 2px;
          border: 1px solid rgba(240, 240, 240, 1);
        }
      }
    }
  }
  .form {
    /deep/.actives {
      .el-form-item__label::before {
        content: "*";
        display: inline-block;
        vertical-align: middle;
        color: #f56c6c;
        margin-right: 4px;
        font-size: 20px;
      }
    }
  }
  .tips-span {
    opacity: 0.6;
    font-size: 12px;
    padding-left: 30px;
    position: relative;
    top: -10px;
  }
}
</style>
